const NotActiveVideoIcon = () => {
    return (
        <svg width="270" height="233" viewBox="0 0 810 672" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="All Done">
                <mask id="mask0_3964_52069" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="810" height="670">
                    <path id="Clip 90" fill-rule="evenodd" clip-rule="evenodd" d="M0 669.263H810V0H0V669.263Z" fill="white" />
                </mask>
                <g mask="url(#mask0_3964_52069)">
                    <path
                        id="Fill 1"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M536.81 189.268C665.57 189.268 769.964 293.665 769.964 422.422C769.964 551.178 665.57 655.576 536.81 655.576C408.028 655.576 303.656 551.178 303.656 422.422C303.656 293.665 408.028 189.268 536.81 189.268ZM671.882 429.382C697.297 421.138 711.185 393.841 702.942 368.426C694.701 343.04 667.401 329.121 641.986 337.392C616.603 345.636 602.683 372.933 610.952 398.319C619.196 423.734 646.493 437.654 671.882 429.382ZM650.166 496.185C634.478 474.564 604.246 469.772 582.625 485.488C561.001 501.176 556.212 531.44 571.928 553.033C587.616 574.654 617.877 579.446 639.47 563.729C661.091 548.041 665.883 517.777 650.166 496.185ZM488.438 296.118C488.438 322.816 510.087 344.466 536.814 344.466C563.512 344.466 585.162 322.816 585.162 296.118C585.162 269.391 563.512 247.741 536.814 247.741C510.087 247.741 488.438 269.391 488.438 296.118ZM501.685 553.033C517.373 531.44 512.584 501.176 490.963 485.488C469.368 469.772 439.104 474.564 423.416 496.185C407.699 517.777 412.491 548.041 434.112 563.729C455.733 579.446 485.971 574.654 501.685 553.033ZM370.661 368.426C362.418 393.841 376.309 421.138 401.724 429.382C427.138 437.654 454.407 423.734 462.682 398.319C470.923 372.933 457.031 345.636 431.62 337.392C406.202 329.121 378.933 343.04 370.661 368.426Z"
                        fill="#FEFEFE"
                    />
                    <path
                        id="Fill 3"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M680.578 422.42C680.578 501.825 616.208 566.194 536.801 566.194C457.396 566.194 393.023 501.825 393.023 422.42C393.023 343.015 457.396 278.643 536.801 278.643C616.208 278.643 680.578 343.015 680.578 422.42Z"
                        fill="#E8E9EB"
                    />
                    <path
                        id="Fill 5"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M670.596 422.419C670.596 496.31 610.696 556.213 536.802 556.213C462.908 556.213 403.008 496.31 403.008 422.419C403.008 348.526 462.908 288.625 536.802 288.625C610.696 288.625 670.596 348.526 670.596 422.419Z"
                        fill="#2C2C36"
                    />
                    <path
                        id="Fill 7"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M671.869 429.381C646.483 437.653 619.182 423.736 610.942 398.318C602.67 372.932 616.59 345.635 641.976 337.391C667.39 329.119 694.688 343.039 702.931 368.425C711.172 393.84 697.283 421.137 671.869 429.381ZM639.46 563.731C617.865 579.445 587.604 574.655 571.916 553.034C556.199 531.439 560.991 501.175 582.612 485.487C604.233 469.77 634.469 474.562 650.157 496.184C665.87 517.776 661.081 548.043 639.46 563.731ZM488.426 296.117C488.426 269.39 510.075 247.741 536.802 247.741C563.503 247.741 585.153 269.39 585.153 296.117C585.153 322.815 563.503 344.465 536.802 344.465C510.075 344.465 488.426 322.815 488.426 296.117ZM501.685 553.034C485.969 574.655 455.73 579.445 434.112 563.731C412.491 548.043 407.699 517.776 423.416 496.184C439.104 474.562 469.368 469.77 490.96 485.487C512.581 501.175 517.373 531.439 501.685 553.034ZM370.638 368.425C378.91 343.039 406.179 329.119 431.593 337.391C457.008 345.635 470.899 372.932 462.656 398.318C454.384 423.736 427.115 437.653 401.7 429.381C376.286 421.137 362.394 393.84 370.638 368.425ZM536.801 201.817C414.95 201.817 316.172 300.567 316.172 422.424C316.172 544.249 414.95 643.024 536.801 643.024C658.626 643.024 757.407 544.249 757.407 422.424C757.407 300.567 658.626 201.817 536.801 201.817Z"
                        fill="#E8E9EB"
                    />
                    <path
                        id="Fill 13"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M575.841 422.42C575.841 443.978 558.365 461.452 536.807 461.452C515.251 461.452 497.777 443.978 497.777 422.42C497.777 400.861 515.251 383.388 536.807 383.388C558.365 383.388 575.841 400.861 575.841 422.42Z"
                        fill="#AFB0B5"
                    />
                    <path
                        id="Fill 15"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M564.405 422.42C564.405 437.663 552.049 450.019 536.803 450.019C521.56 450.019 509.203 437.663 509.203 422.42C509.203 407.177 521.56 394.82 536.803 394.82C552.049 394.82 564.405 407.177 564.405 422.42Z"
                        fill="#1A1A24"
                    />
                    <path
                        id="Fill 17"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M227.404 417.234C223.661 430.72 209.696 438.615 196.213 434.873C182.73 431.13 174.831 417.165 178.574 403.682C182.316 390.196 196.281 382.3 209.765 386.043C223.251 389.785 231.146 403.75 227.404 417.234Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 19"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M192.001 407.407C188.259 420.891 174.294 428.789 160.811 425.046C147.327 421.304 139.429 407.339 143.171 393.856C146.914 380.37 160.879 372.474 174.362 376.217C187.848 379.959 195.744 393.924 192.001 407.407Z"
                        fill="#FBE381"
                    />
                    <path
                        id="Fill 21"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M282.154 410.85C278.411 424.333 264.446 432.231 250.963 428.489C237.48 424.747 229.581 410.781 233.324 397.298C237.066 383.812 251.031 375.917 264.515 379.659C277.998 383.401 285.896 397.367 282.154 410.85Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 23"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M246.763 401.024C243.021 414.51 229.055 422.405 215.572 418.663C202.089 414.92 194.191 400.955 197.933 387.472C201.675 373.986 215.641 366.09 229.124 369.833C242.607 373.575 250.505 387.54 246.763 401.024Z"
                        fill="#FBE381"
                    />
                    <path
                        id="Fill 25"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M235.468 357.247C239.71 343.912 253.958 336.541 267.292 340.783C280.63 345.024 288.001 359.272 283.759 372.607C279.518 385.944 265.267 393.315 251.932 389.073C238.597 384.832 231.227 370.581 235.468 357.247Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 27"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M171.144 357.247C175.386 343.912 189.633 336.541 202.971 340.783C216.306 345.024 223.677 359.272 219.435 372.607C215.194 385.944 200.946 393.315 187.608 389.073C174.273 384.832 166.903 370.581 171.144 357.247Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 29"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M320.546 317.695C324.788 304.36 339.035 296.986 352.373 301.228C365.708 305.469 373.079 319.72 368.837 333.055C364.596 346.39 350.348 353.763 337.01 349.519C323.678 345.277 316.305 331.03 320.546 317.695Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 31"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M270.472 368.383C274.714 355.049 288.964 347.675 302.299 351.919C315.634 356.158 323.004 370.409 318.763 383.743C314.521 397.078 300.274 404.452 286.939 400.21C273.604 395.966 266.231 381.718 270.472 368.383Z"
                        fill="#FBE381"
                    />
                    <path
                        id="Fill 33"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M278.254 403.448C282.495 390.114 296.743 382.743 310.08 386.985C323.415 391.223 330.786 405.474 326.544 418.809C322.303 432.143 308.055 439.517 294.718 435.275C281.383 431.031 274.012 416.783 278.254 403.448Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 35"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M313.269 414.584C317.511 401.249 331.758 393.879 345.093 398.12C358.431 402.362 365.802 416.609 361.56 429.947C357.319 443.282 343.071 450.655 329.733 446.411C316.398 442.17 309.028 427.922 313.269 414.584Z"
                        fill="#FBE381"
                    />
                    <path
                        id="Fill 37"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M280.116 363.931C266.67 360.057 258.908 346.015 262.782 332.569C266.658 319.123 280.698 311.361 294.144 315.235C307.59 319.111 315.351 333.151 311.478 346.597C307.604 360.046 293.562 367.804 280.116 363.931Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 39"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M327.692 416.545C314.246 412.671 306.485 398.629 310.361 385.183C314.235 371.737 328.277 363.975 341.723 367.852C355.169 371.725 362.931 385.765 359.054 399.214C355.181 412.66 341.138 420.418 327.692 416.545Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 41"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M355.748 378.036C342.302 374.163 334.541 360.121 338.415 346.674C342.291 333.228 356.33 325.467 369.776 329.341C383.225 333.217 390.984 347.256 387.11 360.703C383.237 374.152 369.195 381.91 355.748 378.036Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 43"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M364.595 418.595C351.148 414.721 343.387 400.679 347.263 387.233C351.137 373.787 365.179 366.025 378.625 369.902C392.072 373.775 399.833 387.815 395.956 401.264C392.083 414.71 378.041 422.468 364.595 418.595Z"
                        fill="#FBE381"
                    />
                    <path
                        id="Fill 45"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M408.49 371.79C422.481 371.981 433.671 383.482 433.477 397.473C433.286 411.467 421.788 422.654 407.794 422.463C393.803 422.269 382.616 410.771 382.807 396.78C382.998 382.786 394.496 371.599 408.49 371.79Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 47"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M389.271 334.999C403.262 335.19 414.452 346.691 414.258 360.682C414.067 374.676 402.569 385.863 388.575 385.672C374.584 385.478 363.397 373.98 363.588 359.989C363.779 345.995 375.28 334.808 389.271 334.999Z"
                        fill="#FBE381"
                    />
                    <path
                        id="Fill 49"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M312.33 375.066C298.884 371.192 291.123 357.15 294.997 343.704C298.873 330.258 312.915 322.496 326.359 326.373C339.808 330.246 347.569 344.286 343.692 357.735C339.819 371.181 325.777 378.939 312.33 375.066Z"
                        fill="#FBE381"
                    />
                    <path
                        id="Fill 51"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M219.237 375.066C205.791 371.192 198.029 357.15 201.903 343.704C205.779 330.258 219.821 322.496 233.265 326.373C246.714 330.246 254.472 344.286 250.599 357.735C246.725 371.181 232.683 378.939 219.237 375.066Z"
                        fill="#FBE381"
                    />
                    <path
                        id="Fill 53"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M241.489 349.722C228.043 345.848 220.282 331.806 224.158 318.36C228.032 304.914 242.074 297.152 255.517 301.029C268.966 304.902 276.727 318.942 272.851 332.391C268.977 345.837 254.935 353.595 241.489 349.722Z"
                        fill="#FBE381"
                    />
                    <path
                        id="Fill 55"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M410.37 441.512V441.537L406.89 457.245L365.901 642.508L364.484 648.9C363.171 654.787 357.926 659.014 351.879 659.014H202.656C196.823 659.014 191.715 655.11 190.214 649.462L188.343 642.533V642.508L138.923 459.892L133.945 441.512V441.483C134.402 424.201 148.127 410.312 165.011 410.312C176.383 410.312 186.281 416.625 191.74 425.992C191.766 426.046 191.795 426.1 191.82 426.152C197.225 416.707 207.18 410.312 218.604 410.312C230.002 410.312 239.957 416.707 245.388 426.152C245.388 426.152 245.388 426.123 245.414 426.123C250.819 416.707 260.745 410.312 272.172 410.312C283.41 410.312 293.254 416.519 298.713 425.752C298.793 425.883 298.876 426.017 298.953 426.152C304.358 416.707 314.313 410.312 325.74 410.312C337.163 410.312 347.115 416.707 352.521 426.152C352.575 426.072 352.629 425.992 352.68 425.912C358.086 416.602 367.986 410.312 379.305 410.312C396.188 410.312 409.913 424.223 410.37 441.512Z"
                        fill="#F1F2F6"
                    />
                    <path
                        id="Fill 57"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M253.539 659.014H218.942L217.017 642.508L191.73 425.992C191.756 426.046 191.785 426.1 191.81 426.152C197.216 416.707 207.17 410.312 218.594 410.312C229.992 410.312 239.947 416.707 245.378 426.152C245.378 426.152 245.378 426.126 245.404 426.126L252.948 642.508L253.539 659.014Z"
                        fill="url(#paint0_linear_3964_52069)"
                    />
                    <path
                        id="Fill 59"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M352.672 425.913L326.798 642.508L324.819 659.015H287.145L287.975 642.508L298.705 425.75C298.785 425.884 298.865 426.018 298.945 426.152C304.35 416.705 314.305 410.313 325.729 410.313C337.155 410.313 347.107 416.705 352.513 426.152C352.567 426.072 352.618 425.99 352.672 425.913Z"
                        fill="url(#paint1_linear_3964_52069)"
                    />
                    <path
                        id="Fill 61"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M365.89 642.508L364.472 648.9C363.16 654.79 357.918 659.014 351.868 659.014H202.648C196.815 659.014 191.704 655.109 190.206 649.462L188.332 642.533V642.508H365.89Z"
                        fill="#DCDCDC"
                    />
                    <path
                        id="Fill 63"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M226.248 642.507C226.248 657.286 214.268 669.263 199.49 669.263C184.712 669.263 172.734 657.286 172.734 642.507C172.734 627.729 184.712 615.749 199.49 615.749C214.268 615.749 226.248 627.729 226.248 642.507Z"
                        fill="#FBCF0A"
                    />
                    <path
                        id="Fill 65"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M187.459 642.507C187.459 657.286 175.479 669.263 160.704 669.263C145.925 669.263 133.945 657.286 133.945 642.507C133.945 627.729 145.925 615.749 160.704 615.749C175.479 615.749 187.459 627.729 187.459 642.507Z"
                        fill="#FBE381"
                    />
                    <path
                        id="Fill 67"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M506.3 229.324L446.625 348.071C444.751 351.802 440.188 353.311 436.459 351.437C432.731 349.563 431.194 344.988 433.071 341.26L492.817 222.367C494.725 218.747 499.252 217.307 502.934 219.158C504.8 220.093 506.115 221.714 506.719 223.545C506.91 224.118 507.042 224.754 507.065 225.365C507.181 226.68 506.939 228.057 506.3 229.324Z"
                        fill="url(#paint2_linear_3964_52069)"
                    />
                    <path
                        id="Fill 69"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M506.305 229.324L503.376 235.157L488.016 231.931L492.822 222.367L507.07 225.365C507.186 226.68 506.944 228.057 506.305 229.324Z"
                        fill="#FEFEFE"
                    />
                    <path
                        id="Fill 71"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M499.378 243.118L494.569 252.682L479.215 249.456L484.018 239.892L499.378 243.118Z"
                        fill="#FEFEFE"
                    />
                    <path
                        id="Fill 73"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M490.554 260.641L485.748 270.206L470.379 267.002L475.182 257.438L490.554 260.641Z"
                        fill="#FEFEFE"
                    />
                    <path
                        id="Fill 75"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M481.75 278.19L476.944 287.754L461.59 284.528L466.393 274.964L481.75 278.19Z"
                        fill="#FEFEFE"
                    />
                    <path
                        id="Fill 77"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M472.953 295.714L468.143 305.278L452.789 302.052L457.592 292.488L472.953 295.714Z"
                        fill="#FEFEFE"
                    />
                    <path
                        id="Fill 79"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M464.14 313.24L459.333 322.804L443.965 319.6L448.771 310.036L464.14 313.24Z"
                        fill="#FEFEFE"
                    />
                    <path
                        id="Fill 81"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M455.316 330.787L450.51 340.351L435.152 337.125L439.959 327.561L455.316 330.787Z"
                        fill="#FEFEFE"
                    />
                    <path
                        id="Fill 83"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M511.861 662.17H390.447C383.199 662.17 377.215 656.5 376.827 649.263L360.129 338.413H544.749L525.473 649.375C525.028 656.565 519.067 662.17 511.861 662.17Z"
                        fill="url(#paint3_linear_3964_52069)"
                    />
                    <path
                        id="Fill 85"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M554.795 338.414H350.105C347.276 338.414 344.977 336.117 344.977 333.285C344.977 330.453 347.276 328.156 350.105 328.156H554.795C557.627 328.156 559.924 330.453 559.924 333.285C559.924 336.117 557.627 338.414 554.795 338.414Z"
                        fill="#E8E9EB"
                    />
                    <path
                        id="Fill 87"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M540.068 328.158H364.812C361.98 328.158 359.684 325.861 359.684 323.029C359.684 320.197 361.98 317.9 364.812 317.9H540.068C542.898 317.9 545.197 320.197 545.197 323.029C545.197 325.861 542.898 328.158 540.068 328.158Z"
                        fill="#FEFEFE"
                    />
                    <path
                        id="Fill 89"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M404.59 662.17H433.131V338.413H404.59V662.17Z"
                        fill="white"
                        fill-opacity="0.5"
                    />
                    <path
                        id="Fill 91"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M469.688 662.17H498.228V338.413H469.688V662.17Z"
                        fill="white"
                        fill-opacity="0.5"
                    />
                    <path
                        id="Fill 92"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M511.266 469.932C523.657 493.935 507.367 526.983 474.884 543.752C442.398 560.518 406.024 554.654 393.634 530.651C381.246 506.648 397.533 473.598 430.019 456.831C462.502 440.065 498.878 445.929 511.266 469.932Z"
                        fill="url(#paint4_linear_3964_52069)"
                    />
                    <path
                        id="Fill 93"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M504.207 473.578C515.106 494.697 500.775 523.777 472.192 538.53C443.611 553.282 411.607 548.122 400.705 527.003C389.806 505.884 404.137 476.807 432.717 462.052C461.298 447.299 493.305 452.462 504.207 473.578Z"
                        fill="#FCFDFB"
                    />
                    <path
                        id="Fill 94"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M420.874 90.1992C408.024 83.9696 397.607 73.6468 391.263 60.8538L386.1 50.4426L382.016 59.2736C375.646 73.0392 364.625 84.1207 350.888 90.5557L341.66 94.8856L351.184 99.6719C362.637 105.428 372.112 114.47 378.399 125.643L386.1 139.326L392.016 128.136C397.909 116.994 406.943 107.824 417.996 101.763L430.54 94.8856L420.874 90.1992Z"
                        fill="#E8E9EB"
                    />
                    <path
                        id="Fill 95"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M455.22 12.3822C451.218 10.4426 447.972 7.22509 445.998 3.24031L444.389 0L443.117 2.7497C441.135 7.03683 437.701 10.4882 433.422 12.4934L430.547 13.8426L433.513 15.3316C437.082 17.1257 440.034 19.941 441.991 23.4209L444.389 27.6824L446.232 24.1996C448.066 20.7283 450.882 17.8702 454.324 15.9848L458.232 13.8426L455.22 12.3822Z"
                        fill="#E8E9EB"
                    />
                    <path
                        id="Fill 96"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M352.493 46.0399C348.492 44.1003 345.246 40.8857 343.272 36.9009L341.663 33.6577L340.391 36.4074C338.408 40.6945 334.974 44.1459 330.696 46.1512L327.82 47.5003L330.79 48.9921C334.355 50.7834 337.307 53.5987 339.264 57.0786L341.663 61.3401L343.506 57.8573C345.343 54.386 348.155 51.5279 351.598 49.6425L355.506 47.5003L352.493 46.0399Z"
                        fill="#E8E9EB"
                    />
                    <path
                        id="Stroke 97"
                        d="M356.335 132.833C327.817 168.437 349.992 194.322 370.03 201.818"
                        stroke="#E8E9EB"
                        stroke-width="0.950795"
                    />
                    <path
                        id="Fill 98"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M53.8159 338.777C47.3467 330.511 43.8069 320.328 43.7556 309.828L43.7128 301.285L38.162 305.795C29.5051 312.823 18.646 316.574 7.49606 316.383L0 316.255L4.74066 322.496C10.4426 330 13.7742 339.034 14.3133 348.444L14.9722 359.967L22.4968 354.494C29.99 349.043 38.9179 345.908 48.1768 345.483L58.6821 344.998L53.8159 338.777Z"
                        fill="url(#paint5_linear_3964_52069)"
                    />
                    <path
                        id="Fill 99"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M101.651 298.507C99.6346 295.931 98.5336 292.759 98.5165 289.49L98.5051 286.829L96.7765 288.232C94.0782 290.423 90.6981 291.589 87.2239 291.532L84.8906 291.493L86.3682 293.435C88.1423 295.774 89.1806 298.586 89.3489 301.516L89.5514 305.104L91.8961 303.401C94.2293 301.704 97.0133 300.726 99.8942 300.594L103.166 300.443L101.651 298.507Z"
                        fill="url(#paint6_linear_3964_52069)"
                    />
                    <path
                        id="Fill 100"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M22.9598 287.511C20.9432 284.935 19.8422 281.763 19.8251 278.494L19.8108 275.833L18.0851 277.236C15.3867 279.427 12.0067 280.596 8.53247 280.537L6.19922 280.497L7.67675 282.439C9.45094 284.778 10.4892 287.591 10.6575 290.52L10.86 294.111L13.2047 292.405C15.5379 290.708 18.3218 289.733 21.2028 289.599L24.4744 289.447L22.9598 287.511Z"
                        fill="url(#paint7_linear_3964_52069)"
                    />
                    <path
                        id="Fill 101"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M158.893 356.036L156.163 356.866C153.248 347.268 144.999 337.758 135.152 332.641C129.242 329.566 119.955 326.645 109.124 330.185L108.234 327.476C117.55 324.435 127.297 325.339 136.467 330.108C146.961 335.565 155.764 345.742 158.893 356.036Z"
                        fill="url(#paint8_linear_3964_52069)"
                    />
                    <path
                        id="Fill 102"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M158.03 271.611L159.639 273.967C151.358 279.627 144.758 290.346 142.824 301.273C141.663 307.834 141.66 317.569 148.283 326.839L145.964 328.499C140.271 320.524 138.215 310.954 140.017 300.777C142.077 289.131 149.148 277.681 158.03 271.611Z"
                        fill="url(#paint9_linear_3964_52069)"
                    />
                </g>
            </g>
            <defs>
                <linearGradient id="paint0_linear_3964_52069" x1="222.635" y1="285.961" x2="106.209" y2="314.896" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF8960" />
                    <stop offset="1" stop-color="#FF62A5" />
                </linearGradient>
                <linearGradient id="paint1_linear_3964_52069" x1="319.908" y1="285.962" x2="197.36" y2="318.251" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF8960" />
                    <stop offset="1" stop-color="#FF62A5" />
                </linearGradient>
                <linearGradient id="paint2_linear_3964_52069" x1="469.681" y1="151.404" x2="355.647" y2="215.131" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#B739F3" />
                    <stop offset="1" stop-color="#6950FB" />
                </linearGradient>
                <linearGradient id="paint3_linear_3964_52069" x1="485.265" y1="108.012" x2="132.888" y2="270.28" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1162D7" />
                    <stop offset="0.66199" stop-color="#78F3E3" />
                    <stop offset="1" stop-color="#52E5BB" />
                </linearGradient>
                <linearGradient id="paint4_linear_3964_52069" x1="474.842" y1="371.812" x2="323.09" y2="517.351" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1162D7" />
                    <stop offset="0.66199" stop-color="#78F3E3" />
                    <stop offset="1" stop-color="#52E5BB" />
                </linearGradient>
                <linearGradient id="paint5_linear_3964_52069" x1="39.7749" y1="259.524" x2="-42.3953" y2="325.88" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1162D7" />
                    <stop offset="0.66199" stop-color="#78F3E3" />
                    <stop offset="1" stop-color="#52E5BB" />
                </linearGradient>
                <linearGradient id="paint6_linear_3964_52069" x1="97.2776" y1="273.823" x2="71.6876" y2="294.488" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1162D7" />
                    <stop offset="0.66199" stop-color="#78F3E3" />
                    <stop offset="1" stop-color="#52E5BB" />
                </linearGradient>
                <linearGradient id="paint7_linear_3964_52069" x1="18.5862" y1="262.825" x2="-7.007" y2="283.49" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1162D7" />
                    <stop offset="0.66199" stop-color="#78F3E3" />
                    <stop offset="1" stop-color="#52E5BB" />
                </linearGradient>
                <linearGradient id="paint8_linear_3964_52069" x1="142.571" y1="303.543" x2="99.5537" y2="360.03" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1162D7" />
                    <stop offset="0.66199" stop-color="#78F3E3" />
                    <stop offset="1" stop-color="#52E5BB" />
                </linearGradient>
                <linearGradient id="paint9_linear_3964_52069" x1="153.112" y1="231.127" x2="109.831" y2="243.572" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#1162D7" />
                    <stop offset="0.66199" stop-color="#78F3E3" />
                    <stop offset="1" stop-color="#52E5BB" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default NotActiveVideoIcon;
